<template>
    <div class="single-badge"
        @click="openDetails"
    >
        <div class="single-badge__icon">
            <img :src="badgeData.displayIcon"
                :alt="badgeData.title"
            >
        </div>
        <div class="single-badge__progress-bar">
            <progress-bar :percentage="Number(badgeData.progressPercentage)"
                :showNumber="false"
            />
        </div>
        <div class="single-badge__title">
            {{ badgeData.displayTitle }}
        </div>
    </div>
</template>

<script>
// 3rd party
import {
    mapActions,
} from 'vuex';

// Components
import progressBar from '@webapp/components/progress/progress-bar.vue';

// Store
import localStoreTypes from '@webapp/store/types.js';

export default {
    name: 'single-badge',
    components: {
        progressBar,
    },
    props: {
        badgeData: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        ...mapActions({
            setModal: localStoreTypes.SET_MODAL,
        }),

        openDetails() {
            const rewardCurrency = 'xp';
            const rewards = this.badgeData.displayRewards.find((reward) => reward.currency === rewardCurrency) || {};

            this.setModal({
                isVisible: true,
                isClosable: true,
                componentToLoad: 'insertcoin-achievement-sheet',
                data: {
                    type: 'badgeInfo',
                    badgeIcon: this.badgeData.displayIcon,
                    progressPercentage: this.badgeData.progressPercentage,
                    badgeTitle: this.badgeData.displayTitle,
                    badgeDesc: this.badgeData.displayDescription,
                    completedAt: this.badgeData.displayCompletedDate,
                    rewardCurrency: rewardCurrency,
                    rewardAmount: rewards.amount || 0,
                    showProgressBar: this.shouldShowProgressBar(this.badgeData),
                },
            });
        },

        shouldShowProgressBar(item) {
            return !item.formattedMetaData.partnerId;
        },
    },
};
</script>

<style lang="scss" scoped>
.single-badge {
    color: $daintree-color;
    display: flex;
    flex-direction: column;
    padding: 0.2rem;
    cursor: pointer;
    flex: auto;
    align-items: stretch;

    @include min-width(md) {
        padding: 1rem;
    }

    &__icon {
        text-align: center;

        img {
            width: 11rem;

            @include min-width(md) {
                width: 14rem;
            }
        }
    }

    &__progress-bar {
        margin: 0 0 1rem;
        width: 33.3%;
        align-self: center;
    }

    &__title {
        font-size: 1.2rem;
        font-weight: 400;
        text-align: center;

        @include min-width(md) {
            font-size: 1.5rem;
        }
    }
}
</style>